import { render, staticRenderFns } from "./Shortcuts.vue?vue&type=template&id=1a976f1d&scoped=true&"
import script from "./Shortcuts.vue?vue&type=script&lang=js&"
export * from "./Shortcuts.vue?vue&type=script&lang=js&"
import style0 from "./Shortcuts.vue?vue&type=style&index=0&id=1a976f1d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a976f1d",
  null
  
)

export default component.exports